import React from "react"
import { cn } from "@/lib/utils"

export const Button = ({
    className,
    type = "button",
    ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button
        type={type}
        className={cn("inline-flex items-center justify-center gap-2 whitespace-nowrap disabled:pointer-events-none disabled:opacity-50", className)}
        {...props}
    />
)
